module.exports = __webpack_public_path__ + "img/9.5401045b.jpg";